<ng-template #noData>
  <datagrid-no-data [noData]="config.noData"></datagrid-no-data>
</ng-template>

<ng-template #error>
  <datagrid-error [error]="config.error"></datagrid-error>
</ng-template>

<ng-template
  #cellOptions
  let-rowIndex="index"
  let-row="row"
  let-column="column"
  role="table"
  aria-rowcount="81"
>
  <datagrid-cell-options
    [config]="config"
    [row]="row"
    [column]="column"
    [condition]="condition"
    [dataGridId]="dataGridId"
    (actionClicked)="
      onActionClicked($event.row, $event.action, $event?.clickEvent)
    "
    (datagridRowSelected)="
      viewDetail($event.row, $event.columnProp, $event.routeToProp)
    "
    (datagridSsoRowSelected)="
      viewSSODetail($event.row, $event.columnRoute, $event.columnOptions)
    "
  ></datagrid-cell-options>
</ng-template>

<datagrid-mobile
  [data]="data"
  [isLoading]="isLoading"
  [hasAnErrorOccurred]="hasAnErrorOccurred"
  [cellOptions]="cellOptions"
  [config]="config"
  [rows]="rows"
  [error]="error"
  [noData]="noData"
  [dataGridId]="dataGridId"
  (datagridRowSelected)="
    viewDetail($event.row, $event.columnProp, $event.routeToProp)
  "
></datagrid-mobile>

<section
  class="Datagrid"
  tooltip
  [ngClass]="{ 'is-scrollable': isScrollable }"
  (scroll)="isScrollable && onScroll($event)"
  role="table"
>
  @if (isScrollable) {
    <div
      class="Datagrid__shadow Datagrid__shadow--left"
      #datagridShadowLeft
    ></div>
  }

  <datagrid-header
    [config]="config"
    [data]="data"
    [sortOrder]="sortOrder"
    [(selectedRows)]="selectedRows"
    (sortHeaderClicked)="handleColumnSortByClick($event.event, $event.column)"
  ></datagrid-header>

  <datagrid-body
    [data]="data"
    [isLoading]="isLoading"
    [hasAnErrorOccurred]="hasAnErrorOccurred"
    [config]="config"
    [rows]="rows"
    [error]="error"
    [noData]="noData"
    [cellOptions]="cellOptions"
    [dataGridId]="dataGridId"
    [(selectedRows)]="selectedRows"
  ></datagrid-body>

  <datagrid-footer
    [rows]="rows"
    [config]="config"
    [footerDetail]="footerDetail"
  ></datagrid-footer>

  @if (isScrollable) {
    <div
      class="Datagrid__shadow Datagrid__shadow--right"
      #datagridShadowRight
    ></div>
  }
</section>
